import React from 'react';
import { Link } from 'react-router-dom';
import { collections } from '../data/mockData';
import { PageHero } from '../components/PageHero';
import { RangeCard } from '../components/RangeCard';
import { CardCarousel } from '../components/CardCarousel';

/** Index of the OFFICIAL artist & heritage collections. */
export function Collections() {
  return <div className="w-full bg-paper" data-id="element-341" data-mp="3cfa743w06800">
      <PageHero eyebrow="Shop by Collection" title="The official ranges." intro="Licensed work from the world’s great design archives — William Morris, the Van Gogh Museum, Emma Shipley and Kew Gardens." data-id="element-342" data-mp="3wvy3qn9jsxv" />

      <section className="mx-auto max-w-[1400px] px-6 pb-24" data-id="element-343" data-mp="3r9oqw6ne5lfq">
        <CardCarousel data-id="element-344" data-mp="3vbjszdd5c2uk">
          {collections.map((c, i) => <RangeCard key={c.id} range={c} index={i} data-id="element-345" data-mp="3v9z1xxq1j21g" data-mpi={i} />)}
        </CardCarousel>

        <div className="mt-20 flex flex-col items-start gap-6 rounded-4xl bg-pennant p-10 text-paper md:flex-row md:items-center md:justify-between md:p-12" data-id="element-346" data-mp="mu5ipb4brcgp">
          <div data-id="element-347" data-mp="egwqy6deyxlg">
            <p className="type-eyebrow mb-3 text-[10px] text-paper/60" data-id="element-348" data-mp="egmx27p906ah">
              Looking for something closer to home?
            </p>
            <h2 className="type-display text-3xl text-paper md:text-4xl" data-id="element-349" data-mp="o5oe817j4tq1">
              Choose Your Story
            </h2>
            <p className="type-body mt-3 max-w-lg text-sm text-paper/70" data-id="element-350" data-mp="jeg2uzmn2ya8">
              Our South African ranges — the Karoo, Cape Point, the fynbos and
              one numbered winter release.
            </p>
          </div>
          <Link to="/stories" className="type-cta shrink-0 rounded-full bg-paper px-8 py-4 text-[11px] text-pennant transition-colors hover:bg-oat" data-id="element-351" data-mp="t3zna9q03077">
            View the stories
          </Link>
        </div>
      </section>
    </div>;
}